import { Link } from 'react-router-dom';
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic';
import { LocaleContext } from '../../locale-context';

import Harita from './harita';
import ScholarshipTable from './ScholarshipTable';

export function EgitimeDestek() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="EgitimDestek" /></h1>
          <p>Geleceğe yatırım yapıyoruz. Türkiye'nin dört bir yanındaki okullara ve öğrencilere ulaşıyoruz.</p>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        {/* MAP SECTION */}
        <div className="map-card data-card">
          <div className="card-header">
            <h2><TranslateStatic string="DestekVerdigimiziller" /></h2>
            <div className="legend">
              <div className="legend-color"></div>
              <span>Destek Sağlanan İl</span>
            </div>
          </div>
          <div className="map-container">
            <div className="il-isimleri"></div>
            <Harita />
          </div>
        </div>

        {/* DATA TABLES SECTION */}
        <div className="tables-grid">
          {/* Schools Table */}
          <div className="schools-card data-card">
            <div className="card-header">
              <h2><TranslateStatic string="KitapUzunBaslik" /></h2>
              <span className="badge">65 Okul</span>
            </div>
            <div className="table-responsive">
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th><TranslateStatic string="Sehir" /></th>
                    <th><TranslateStatic string="Okul" /></th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>1</td><td>ARDAHAN</td><td>GÖLBELEN İLKOKULU</td></tr>
                  <tr><td>2</td><td>ANTALYA/MANAVGAT</td><td>BELENOBAŞI İLKOKULU</td></tr>
                  <tr><td>3</td><td>YOZGAT</td><td>GÜLŞEHRİ ORTAOKULU</td></tr>
                  <tr><td>4</td><td>ANTALYA</td><td>VARSAK ŞELALE ORTAOKULU</td></tr>
                  <tr><td>5</td><td>MERSİN</td><td>ANAFARTALAR İLKOKULU</td></tr>
                  <tr><td>6</td><td>MUĞLA</td><td>AHMET İMLİCE ZORLU İLKOKULU</td></tr>
                  <tr><td>7</td><td>GİRESUN</td><td>KÖPRÜBAŞI İLKOKULU</td></tr>
                  <tr><td>8</td><td>KONYA</td><td>AVDAN ORTAOKULU</td></tr>
                  <tr><td>9</td><td>ANKARA</td><td>MAMAK ÇOCUKSEVENLER İLKOKULU</td></tr>
                  <tr><td>10</td><td>İZMİR</td><td>ESİN ÇAĞDAŞ İLKOKULU</td></tr>
                  <tr><td>11</td><td>MANAVGAT</td><td>TGB ETKİNLİĞİ</td></tr>
                  <tr><td>12</td><td>ISPARTA</td><td>YALVAÇ ÖZBAYAT İLKOKULU</td></tr>
                  <tr><td>13</td><td>KÜTAHYA</td><td>SİMAV BEYCE ORTAOKULU</td></tr>
                  <tr><td>14</td><td>ESKİŞEHİR</td><td>TEPE BAŞI SEKİ ÖREN İLKOKULU</td></tr>
                  <tr><td>15</td><td>EDİRNE</td><td>UZUN KÖPRÜ KAVACIK İLKOKULU</td></tr>
                  <tr><td>16</td><td>TRABZON</td><td>DOĞANCI İLKOKULU</td></tr>
                  <tr><td>17</td><td>SAMSUN</td><td>ASARCIK GÖKGÖL ŞEHİT MAHİR EMEN İLKOKULU</td></tr>
                  <tr><td>18</td><td>ZONGULDAK</td><td>GÖKÇEBEY BAKİLER İLKOKULU</td></tr>
                  <tr><td>19</td><td>ORDU</td><td>ŞEHİT HARUN MAYTALMAN İLKOKULU</td></tr>
                  <tr><td>20</td><td>AMASYA</td><td>ÜLKÜ İLKOKULU</td></tr>
                  <tr><td>21</td><td>DENİZLİ</td><td>BELENKÖY İLKÖĞRETİM OKULU</td></tr>
                  <tr><td>22</td><td>ŞIRNAK</td><td>ŞEHİTLER MEHMET ALİ KÜLTÜR OKULU</td></tr>
                  <tr><td>23</td><td>IĞDIR</td><td>DOĞANYURT İLKOKULU</td></tr>
                  <tr><td>24</td><td>NEVŞEHİR</td><td>ACIGÖL ATATÜRK İLKOKULU</td></tr>
                  <tr><td>25</td><td>BOLU</td><td>DÖRT DİVAN KARGI BAYRAMLAR İLKOKULU</td></tr>
                  <tr><td>26</td><td>BURDUR</td><td>TEFENNİ BAŞPINAR İLKOKULU</td></tr>
                  <tr><td>27</td><td>KAYSERİ</td><td>ŞEHİT JANDARMA YARBAY BEKİL TEMEL İLKOKULU</td></tr>
                  <tr><td>28</td><td>KOCAELİ</td><td>KANDIRA SAFALI İLKOKULU</td></tr>
                  <tr><td>29</td><td>BALIKESİR</td><td>YEŞİLDERE İLKOKULU</td></tr>
                  <tr><td>30</td><td>AFYON</td><td>İNLİ İLKOKULU</td></tr>
                  <tr><td>31</td><td>MALATYA</td><td>AYVALI İLKOKULU</td></tr>
                  <tr><td>32</td><td>SİVAS</td><td>İSTİKLAL İLKOKULU</td></tr>
                  <tr><td>33</td><td>ÇANAKKALE</td><td>HÜSEYİN AKİF TERZİOĞLU İLKOKULU</td></tr>
                  <tr><td>34</td><td>HATAY</td><td>ERZİN YONCADÜZÜ İLKOKULU</td></tr>
                  <tr><td>35</td><td>VAN</td><td>ERCİŞ ÇAKIRBEY İLKOKULU</td></tr>
                  <tr><td>36</td><td>ERZURUM</td><td>HORASAN FEHMİ BİLGE İLKOKULU</td></tr>
                  <tr><td>37</td><td>KAHRAMANMARAŞ</td><td>EŞE VE YUSUF GÜLKAYNAK İLKOKULU</td></tr>
                  <tr><td>38</td><td>AĞRI</td><td>ELEŞKİRT SALKIMLI KÖYÜ İLKOKULU</td></tr>
                  <tr><td>39</td><td>TUNCELİ</td><td>MAZGİRT AKPAZAR İLKOKULU</td></tr>
                  <tr><td>40</td><td>NİĞDE</td><td>YENİYILDIZ İLKOKULU</td></tr>
                  <tr><td>41</td><td>DİYARBAKIR</td><td>DORUK İLKOKULU</td></tr>
                  <tr><td>42</td><td>KİLİS</td><td>YEDİGÖZ İLKOKULU</td></tr>
                  <tr><td>43</td><td>VAN</td><td>YAHYA KEMAL BEYATLI İLKOKULU</td></tr>
                  <tr><td>44</td><td>KASTAMONU</td><td>ALATARLA İLKOKULU</td></tr>
                  <tr><td>45</td><td>MARDİN MİDYAT</td><td>FAHRETTİN ÖNEN İLKOKULU</td></tr>
                  <tr><td>46</td><td>BATMAN</td><td>YEŞİLOBA İLKOKULU</td></tr>
                  <tr><td>47</td><td>ELAZIĞ</td><td>MAHİR ÖZDEMİR İLKOKULU</td></tr>
                  <tr><td>48</td><td>AKSARAY</td><td>ORTAKÖY FATİH İLKOKULU</td></tr>
                  <tr><td>49</td><td>SİNOP</td><td>SARIKADI İLKOKULU</td></tr>
                  <tr><td>50</td><td>KONYA</td><td>SADIKHACI İLKOKULU</td></tr>
                  <tr><td>51</td><td>KARS(KAĞIZMAN)</td><td>PASLI ESİN ÇAĞDAŞ İLK-ORTAOKULU</td></tr>
                  <tr><td>52</td><td>ŞANLIURFA</td><td>ŞENOCAK ORTAOKULU</td></tr>
                  <tr><td>53</td><td>OSMANİYE</td><td>KARACAOĞLAN ORTAOKULU</td></tr>
                  <tr><td>54</td><td>ADIYAMAN</td><td>YAZBAŞI ORTAOKULU</td></tr>
                  <tr><td>55</td><td>ARTVİN</td><td>KEMAL PAŞA ORTAOKULU</td></tr>
                  <tr><td>56</td><td>BAYBURT</td><td>BAYBURT ORTAOKULU</td></tr>
                  <tr><td>57</td><td>RİZE</td><td>ATATÜRK ORTAOKULU</td></tr>
                  <tr><td>58</td><td>DENİZLİ/TAVAS</td><td>YAHŞİLER İLKÖĞRETİM / ORTAOKULU</td></tr>
                  <tr><td>59</td><td>AYDIN</td><td>GÖLHİSAR KÖYÜ İLKOKULU</td></tr>
                  <tr><td>60</td><td>HAKKARİ</td><td>GELİŞEN KÖYÜ KÜTÜKLÜ MEZRASI İLKOKULU</td></tr>
                  <tr><td>61</td><td>ADANA/SARIÇAM</td><td>AVCILAR İLKOKULU</td></tr>
                  <tr><td>62</td><td>ERZİNCAN</td><td>TÜRK TELEKOM BİNALİ YILDIRIM İLKOKULU</td></tr>
                  <tr><td>63</td><td>BARTIN</td><td>AHMETLER İLKOKULU</td></tr>
                  <tr><td>64</td><td>GÜMÜŞHANE</td><td>GÜMÜŞGÖZÜ İLKOKULU</td></tr>
                  <tr><td>65</td><td>MUŞ</td><td>ÇUKURBAĞ İLKOKULU</td></tr>
                </tbody>
              </table>
            </div>
          </div>
          
          {/* Scholarships Component */}
          <ScholarshipTable />
        </div>
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
